import React, { createContext, useContext, useState, useCallback } from 'react';
import { API_URL } from '../../config/env';

export const USER_STORAGE_KEY = 'admin_current_user';

const CurrentUserContext = createContext();

export function CurrentUserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = window.localStorage.getItem(USER_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  const fetchCurrentUser = useCallback(async (accessToken) => {
    const res = await fetch(`${API_URL}/v1/admin/users/me`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) {
      const err = new Error('Failed to fetch user');
      err.status = res.status;
      throw err;
    }
    const data = await res.json();
    setUser(data);
    window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(data));
    return data;
  }, []);

  const clearCurrentUser = useCallback(() => {
    setUser(null);
    window.localStorage.removeItem(USER_STORAGE_KEY);
  }, []);

  const getCurrentUserEmail = useCallback(() => {
    const stored = window.localStorage.getItem(USER_STORAGE_KEY);
    if (!stored) return null;
    try {
      const user = JSON.parse(stored);
      return user.email || null;
    } catch {
      return null;
    }
  }, []);

  // Add updateCurrentUser to update state and localStorage
  const updateCurrentUser = useCallback((newUser) => {
    setUser(newUser);
    window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(newUser));
  }, []);

  return (
    <CurrentUserContext.Provider
      value={{ user, fetchCurrentUser, getCurrentUserEmail, updateCurrentUser, clearCurrentUser }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
}

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}
